import { Photo } from "@/components/Photo";
import { heroPhoto } from "@/components/hero/heroPhoto";
import { HERO_FETCH_PRIORITY, HERO_LAYOUTS } from "@/lib/heroImage";
import { useHeroPhotoProbe } from "@/components/hero/heroHeader";
import { HeroStatement } from "@/components/hero/HeroStatement";
import { useRef } from "react";

export function Hero() {
  const ref = useRef<HTMLElement>(null);
  useHeroPhotoProbe(ref);

  return (
    <div className="px-2 pt-2 sm:px-4 sm:pt-4">
      <section
        ref={ref}
        id="top"
        className="relative h-[80svh] max-h-[50.75rem] min-h-[35rem] overflow-hidden sm:h-[75vw] sm:max-h-[67.8125rem] sm:min-h-[40rem] rounded-3xl bg-inverse text-inverse"
      >
        <Photo
          loading="eager"
          {...HERO_FETCH_PRIORITY}
          src={heroPhoto.src}
          srcSet={heroPhoto.srcSet}
          sizes={HERO_LAYOUTS.stacked.sizes}
          alt="Park Hyatt guest villa at dusk with warm lighting over the pool terrace"
          className="absolute inset-0"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/50 to-transparent to-70%"
        />
        <div className="relative">
          <HeroStatement />
        </div>
      </section>
    </div>
  );
}
